import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginPageComponent } from '@app/Pages/login-page/login-page.component';
import { AuthGuardService as AuthGuard } from "@app/services/auth.guard";
import {RoleGuard} from "@app/services/role.guard";

// @ts-ignore
const routes: Routes = [
  { path: 'login', component: LoginPageComponent },
  { path: 'home',  canActivate: [AuthGuard, RoleGuard],loadChildren: () => import("./Pages/main-content/main-content.module").then(m => m.MainContentModule)},
  { path: '', redirectTo: 'home', pathMatch: 'full'},
  { path: '**', redirectTo: 'login-page', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
